import Client from '@/repositories/clients/AuthenticatedClient';

/**
 * Unified my-KPIs store API (`/kpis`).
 *
 * Backs both the Mijn-omgeving KPI card and the home pulse strip. Role-based
 * seeds and self-made KPIs are the same `custom_kpi` asset; they differ only by
 * `origin`. Functions UNWRAP the response and return camelCased domain objects.
 */
const KPI_BASE_PATH = '/kpis';

export function normalizeMyKpi(item = {}) {
  return {
    id: item.id,
    origin: item.origin || 'self-made',
    title: item.title || item.id,
    unit: item.unit || '',
    deepLink: item.deep_link || '',
    datasetId: item.dataset_id || null,
    seriesId: item.series_id || null,
    kpiQuery: item.kpi_query ?? null,
    versionToken: item.version_token || '',
    editable: item.editable !== false,
    // Keep the snake_case KpiValueResponse intact — the shared KpiCard renders
    // it directly (same payload as the pulse strip).
    kpiValue: item.kpi_value || null,
    error: item.error || null,
  };
}

export async function listMyKpis(limit = null) {
  const response = await Client.get(KPI_BASE_PATH, {
    params: limit ? { limit } : {},
  });
  return (response.data?.items || []).map(normalizeMyKpi);
}

export async function createMyKpi({ title, datasetId, seriesId, kpiQuery, deepLink } = {}) {
  const response = await Client.post(KPI_BASE_PATH, {
    title: title || null,
    dataset_id: datasetId,
    series_id: seriesId || null,
    kpi_query: kpiQuery,
    deep_link: deepLink || null,
  });
  return normalizeMyKpi(response.data);
}

export async function updateMyKpi(id, { title, kpiQuery, versionToken } = {}) {
  const response = await Client.put(`${KPI_BASE_PATH}/${id}`, {
    title: title ?? null,
    kpi_query: kpiQuery ?? null,
    version_token: versionToken,
  });
  return normalizeMyKpi(response.data);
}

export async function deleteMyKpi(id) {
  await Client.delete(`${KPI_BASE_PATH}/${id}`);
}

export async function reorderMyKpis(order = []) {
  await Client.patch(`${KPI_BASE_PATH}/order`, { order });
}
